import { Injectable } from '@angular/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { SugestionInput } from '@radioking/ui/input';
import moment from 'moment-timezone';

import { Slot, SlotOccurrence } from '../models/planning.model';

@Injectable({
  providedIn: 'root',
})
export class PlanningUtilsService {
  static slotRepeatFrequency: SugestionInput[] = [
    {
      id: '1',
      name: 'daily',
      translation: marker('SCHEDULE.PLANNING.ENUMS.BREAK_CUSTOM_REPEAT_FREQUENCY.DAILY'),
    },
    {
      id: '7',
      name: 'weekly',
      translation: marker('SCHEDULE.PLANNING.ENUMS.BREAK_CUSTOM_REPEAT_FREQUENCY.WEEKLY'),
    },
    {
      id: '14',
      name: 'two_weeks',
      translation: marker(
        'SCHEDULE.PLANNING.ENUMS.BREAK_CUSTOM_REPEAT_FREQUENCY.TWO_WEEKS',
      ),
    },
  ];

  /**
   * Modifies specified dates to ensure they are on the same day
   */
  static restrictStartEndDatesToSameDay(start: moment.Moment, end: moment.Moment): void {
    if (!end.isSame(start, 'day')) {
      end.set({ ...start.toObject(), hours: 23, minutes: 59 });
    }
  }

  /**
   * Created all occurrences from new slot, to prevent event overlap
   * @param slot the new created/edited slot
   */
  static slotToOccurrences(slot: Slot): SlotOccurrence[] {
    const slotAllOccurrences: SlotOccurrence[] = [];
    if (slot.repeat) {
      if (slot.repeat.repeatInterval === 1) {
        // Repeat every day
        const startDate = slot.start.clone();
        const endDate = startDate.clone().set({
          hours: slot.end.hours(),
          minutes: slot.end.minutes(),
        });
        if (slot.repeat.repeatCount) {
          // Repetition x times
          for (let i = 0; i < slot.repeat.repeatCount; i++) {
            slotAllOccurrences.push({
              id: -1,
              startDate: startDate.clone(),
              endDate: endDate.clone(),
            });
            startDate.add(1, 'day');
            endDate.add(1, 'day');
          }
        } else if (slot.repeat.repeatEnd) {
          // Repetition until specified date
          while (startDate.isSameOrBefore(slot.repeat.repeatEnd, 'day')) {
            slotAllOccurrences.push({
              id: -1,
              startDate: startDate.clone(),
              endDate: endDate.clone(),
            });
            startDate.add(1, 'day');
            endDate.add(1, 'day');
          }
        }
      } else if (slot.repeat.repeatDays) {
        // Repeat every week / two weeks
        slot.repeat.repeatDays.split(',').forEach(day => {
          const startDate = slot.start.clone().day(Number.parseInt(day, 10) % 7);
          let ok = startDate.isSameOrAfter(slot.start);
          if (slot.repeat.repeatEnd) {
            ok = ok && startDate.isSameOrBefore(slot.repeat.repeatEnd, 'day');
          }
          if (ok) {
            const endDate = startDate.clone().set({
              hours: slot.end.hours(),
              minutes: slot.end.minutes(),
            });
            slotAllOccurrences.push({
              id: -1,
              startDate: startDate.clone(),
              endDate: endDate.clone(),
            });
          }
        });
      }
    } else {
      slotAllOccurrences.push({
        id: -1,
        startDate: slot.start,
        endDate: slot.end,
      });
    }
    return slotAllOccurrences;
  }
}
